module.exports = __webpack_public_path__ + "img/practice_05.8c1408ed.jpeg";